//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Areas from '~/utils/areas'
import getMenusWithArea from '~/gql/getMenusWithArea'
import userMixin from '~/mixins/user'

export default {
  mixins: [userMixin],
  data() {
    return {
      activeMainMenu: null,
      activeSubmenu: null,
      userBranch: process.env.USER_BRANCH,
      menuItemsMeta: [],
      menuItemsMain: [],
    }
  },
  async fetch() {
    const { sectionMenus } = await this.$graphcms.request(getMenusWithArea, {
      area: [Areas.HEADER_MODERN, Areas.USERLINKS_MODERN],
      lang: [this.$i18n.locale],
    })
    this.menuItemsMeta = sectionMenus[0]?.menuItems
    this.menuItemsMain = sectionMenus
  },

  computed: {
    theme() {
      return this.$store.state.global.theme
    },
  },

  watch: {
    $route(to, from) {
      this.close()
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    backToStartMenu() {
      this.activeMainMenu = null
    },
    backToMainMenu() {
      this.activeSubmenu = null
    },
    openMainMenu(index) {
      if (this.activeMainMenu === this.menuItemsMain[index]) {
        this.activeMainMenu = null
      } else {
        this.activeMainMenu = this.menuItemsMain[index]
      }
    },
    openSubMenu(index) {
      console.log(this.activeMainMenu.menuItemWithSubMenu[index])
      this.activeSubmenu = this.activeMainMenu.menuItemWithSubMenu[index]
    },
    closeSubMenu() {
      this.activeSubmenu = null
    },
    close() {
      this.$store.commit('global/setDrawer', {
        drawer: null,
        layer: false,
      })
      document.body.classList.remove('no-scroll')
    },
    showDrawer(name) {
      this.$store.commit('global/setDrawer', {
        drawer: name,
        layer: false,
      })
      document.body.classList.add('no-scroll')
    },
    handleResize() {
      const breakpoint = 1300
      if (window.innerWidth > breakpoint) {
        this.close()
      }
    },
    search() {
      this.$store.commit('global/setDialog', {
        dialog: 'search-bar',
        layer: true,
        props: {
          focus: {
            type: 'cta',
          },
        },
      })

      if (this.userBranch !== '') {
        // eslint-disable-next-line no-undef
        const currentPageURL = window.location.href
        // eslint-disable-next-line no-undef
        window._mtm = window._mtm || []
        // eslint-disable-next-line no-undef
        window._mtm.push({
          event: 'site-search-tracking',
          'event-category': 'site-search-tracking',
          'event-action': `CLICK_LINK_URL - ${currentPageURL}`,
        })
      }
    },
    url(url) {
      return this.$localeResolver.localePath({
        path: this.parentSlug !== '' ? `/${this.parentSlug}/${url}` : `/${url}`,
      })
    },
  },
}
